import { PRODUCT_LINES } from '../constants/auto'

export const isConiugato = statoCivile =>
  statoCivile === 'CGS' || statoCivile === 'CGC' || statoCivile === 'CON'

export const isDipendente = situazioneLavorativa =>
  ['DPU', 'DPR'].includes(situazioneLavorativa)

export const isRealLavoro = (situazioneLavorativa, tipoContratto = '') => {
  /**
   * e' real lavoro
   * se dipendente indeterminato o autonomo
   */
  if (isDipendente(situazioneLavorativa)) {
    if (tipoContratto !== 'IND') {
      return false
    }
  }

  return ['DPU', 'DPR', 'AUT'].includes(situazioneLavorativa)
}

export const isAutonomo = situazioneLavorativa => situazioneLavorativa === 'AUT'

export const isDipendentePrivato = situazioneLavorativa =>
  situazioneLavorativa === 'DPR'
export const isDirigente = occupazione => occupazione === 'DIR'

export const richiedeCaricaPrivata = (situazioneLavorativa, occupazione) =>
  isDipendentePrivato(situazioneLavorativa) && isDirigente(occupazione)

export const getFromFee = (
  key,
  fee,
  params = {
    addCapKm: false,
    plusServicesCost: 0,
  }
) => {
  const currentKey =
    fee.canone_promo && fee.canone_promo[key] ? fee.canone_promo[key] : fee[key]

  if (!currentKey) {
    return false
  }

  if (params.plusServicesCost) {
    return currentKey + params.plusServicesCost
  }

  if (params.addCapKm) {
    return currentKey + fee.cap_variabile_kilometrico
  }

  return currentKey
}

export const puoNoleggiare = (
  situazioneLavorativa,
  tipoContratto = '',
  isNltBrumbrum = false
) => {
  /**
   * se puo' sottoscrivere
   * un contratto NLT
   */
  if (isDipendente(situazioneLavorativa)) {
    if (tipoContratto && !isNltBrumbrum && tipoContratto !== 'IND') {
      return false
    }
  }

  return ['DPU', 'DPR', 'AUT', 'PEN'].includes(situazioneLavorativa)
}

export const hasValidPermessoDiSoggiorno = (permessoType = '') => {
  if (permessoType === 'temporary') {
    return false
  }

  return true
}

export const puoNoleggiareNltBrumbrum = (
  situazioneLavorativa = '',
  tipoContratto = '',
  nltDati = false,
  customerDati = false
) => {
  if (
    customerDati &&
    !hasValidPermessoDiSoggiorno(customerDati.tipo_permesso_soggiorno)
  ) {
    return false
  }

  if (
    tipoContratto === 'DET' &&
    nltDati &&
    nltDati.dati.data_termine_contratto.raw !== null
  ) {
    if (
      nltDati.dati.data_termine_contratto &&
      nltDati.dati.data_termine_contratto.raw
    ) {
      const splitDate = nltDati.dati.data_termine_contratto.raw.split('/')

      if (splitDate.length !== 3) {
        return false
      }

      const endOfJobContract = new Date(
        splitDate[2],
        splitDate[1],
        splitDate[0]
      )
      const now = new Date()
      const endOfNltContract = now.setMonth(
        now.getMonth() + nltDati.selectedCanone.numero_mensilita
      )

      if (endOfJobContract.getTime() <= endOfNltContract) {
        return false
      }
    }
  }

  return puoNoleggiare(situazioneLavorativa, tipoContratto, true)
}

export const kycArvalApicale = nltDati => {
  if (!['DIR'].includes(nltDati.occupazione)) {
    return false
  }

  return ['DPU'].includes(nltDati.situazione_lavorativa)
}

export const isApicale = nltDati => nltDati.dettaglio_ruolo_pa === 'API'

export const isNlt = productLine =>
  [PRODUCT_LINES.NLT_ARVAL, PRODUCT_LINES.NLT_BRUMBRUM].includes(productLine)

export const isNltBrumbrum = product =>
  product.linea_prodotto === 'NLT_BRUMBRUM' &&
  product.tipo_veicolo &&
  product.tipo_veicolo.toUpperCase() === 'NUOVO'

export function getNltService(product) {
  return isNltBrumbrum(product) ? 'nlt-brumbrum' : 'nlt'
}
